export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5388.396299c8.jpg";